<template>
  <footer class="footer">
    <div
      class="
        container
        mx-auto
        flex-col-reverse flex flex-col
        space-y-2.5
        lg:flex-row lg:justify-between
        relative
      "
    >
      <div class="footer__background-element cpu">
        <vue-feather type="cpu"></vue-feather>
      </div>

      <div class="footer__background-element shield">
        <vue-feather type="shield"></vue-feather>
      </div>

      <div class="flex flex-col items-start space-y-2.5 lg:space-y-10 relative">
        <div class="tomu-navbar-contacts mr-4 space-y-2.5">
          <p class="tomu-navbar-contacts__first">
            <vue-feather class="icon" type="map-pin"></vue-feather> Адрес:
            <span class="tomu-navbar-contacts__address"
              >г. Томск, ул. В. Высоцкого, 25 ст. 3
              <a
                href="/contacts#map"
                class="
                  text-right
                  mr-2
                  block
                  lg:inline
                  text-blue-500
                  hover:text-blue-800
                "
                >(показать на карте)</a
              ></span
            >
          </p>
          <p class="tomu-navbar-contacts__second">
            <vue-feather class="icon" type="phone"></vue-feather>
            <span class="tomu-navbar-contacts__phone-number">
              (3822) <span class="tomu-underline">515-300</span></span
            >
            <vue-feather class="icon" type="mail"></vue-feather>
            <span class="tomu-navbar-contacts__email">
              office@tomuniversal.ru</span
            >
          </p>
        </div>
        <p class="text-gray-400">
          Copyright @ 2021 ТОМ УНИВЕРСАЛ. Все права защищены.
        </p>
      </div>

      <div id="tomu-footer-menu" class="flex relative">
        <div>
          <router-link
            :to="{ name: 'Home' }"
            class="footer__link"
            title="Главная"
          >
            Главная
          </router-link>
          <br />
          <router-link
            :to="{ name: 'DigitalDriverCards' }"
            class="footer__link"
            title="Карты водителя"
          >
            Карты водителя
          </router-link>
          <br />
          <router-link
            :to="{ name: 'VehicleRegistrationPlates' }"
            class="footer__link"
            title="Изготовление гос номеров"
            event=""
          >
            Изготовление гос номеров
          </router-link>
          <br />
          <router-link
            :to="{ name: 'Documents' }"
            class="footer__link"
            title="Документы"
          >
            Документы
          </router-link>
          <br />
          <router-link
            :to="{ name: 'Contacts' }"
            class="footer__link"
            title="Контакты"
          >
            Контакты
          </router-link>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: "AppFooter",
};
</script>

<style scoped>
.footer {
  background-color: #fafafa; /* default */
  @apply bg-gradient-to-r from-gray-50 to-gray-50;
  padding: 3rem 1.5rem 3rem 1.5rem;

  overflow: hidden;

  &__background-element {
    position: absolute;
    opacity: 0.04;

    &.cpu {
      left: 0;
      top: 61px;
      transform: rotate(-108deg) scale(4);
    }

    &.shield {
      opacity: 0.07;
      right: 7rem;
      transform: rotate(10deg) scale(1.7);
      color: #007259;

      @apply hidden md:block;
    }

    :deep(svg) {
      width: 125px;
      height: 125px;
    }
  }
}

#tomu-footer-menu {
  a:hover {
    @apply border-green-500 border-b-2 border-solid;
  }
}
</style>
